import React, {useState} from 'react';
import {MapViewContext, TileCoord} from "./contexts/MapViewContext";
import MapboxMap from "./components/MapboxMap";
import {LngLatBounds} from "mapbox-gl";

const App: React.FC = () => {
    const [mapTileCoords, setMapTileCoords] = useState<TileCoord[]>([]);
    const [viewportBounds, setViewportBounds] = useState<LngLatBounds | null>(null);
    const [hoveredStateId, setHoveredStateId] = useState<string | null>(null);
    const [mapName, setMapName] = useState<string | null>(null);
    const [selectedTagIds, setSelectedTagIds] = useState<string[]>([]);
    const [selectedCategoryIds, setSelectedCategoryIds] = useState<string[]>([]);
    const [searchQuery, setSearchQuery] = useState<string | null>(null);
    const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(false);
    const [selectedStateId, setSelectedStateId] = useState<string | null>(null);

    return (
        <MapViewContext.Provider
            value={{
                mapTileCoords,
                setMapTileCoords,
                viewportBounds,
                setViewportBounds,
                hoveredStateId,
                setHoveredStateId,
                mapName,
                setMapName,
                selectedTagIds,
                setSelectedTagIds,
                selectedCategoryIds,
                setSelectedCategoryIds,
                searchQuery,
                setSearchQuery,
                sidebarCollapsed,
                setSidebarCollapsed,
                selectedStateId,
                setSelectedStateId,
            }}>
            <div style={{display: 'flex', height: '100vh', width: '100vw'}}>
                <div style={{flex: 1, position: 'relative'}}>
                    <MapboxMap />
                </div>
            </div>
        </MapViewContext.Provider>
    );
};

export default App;
